<template>
  <!-- Old bit.dev component -->
  <div class="c-base-operation-box">
    <div class="c-base-operation-box__title">
      <i class="icon">
        <!-- Use this slot to set icon title -->
        <slot name="icon-title"></slot>
      </i>
      {{ title }}
    </div>
    <!-- Use this slot to set content -->
    <slot></slot>
    <div class="c-base-operation-box__footer" v-if="!isFooter">
      <!-- Use this slot to set footer -->
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Use this to define title
    title: {
      type: String,
      required: true,
    },
    // Use this to display footer
    isFooter: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.c-base-operation-box {
  padding: 12px 0;
  background-color: $gray-1;

  &__title {
    display: flex;
    padding-bottom: 18px;
    align-items: center;
    justify-content: center;
    font-size: 1em;
    text-align: center;
    .icon {
      margin-right: 6px;
    }
  }

  &__footer {
    padding-top: 18px;
    text-align: center;
  }
}
</style>
